export default {
  price: {
    key: "price",
    elasticName: "price",
    type: "two-input-range",
    quickType: "two-input-range",
    name: {
      ar: "السعر",
      en: "Price",
    },
    urlName: "price_range",
    fields: {
      ar: [
        {
          placeholder: "السعر الأدنى",
          query: {
            op: "gte",
            value: 0,
          },
        },
        {
          placeholder: "السعر الأعلى",
          query: {
            op: "lte",
            value: 900000000000,
          },
        },
      ],
      en: [
        {
          placeholder: "From price",
          query: {
            op: "gte",
            value: 0,
          },
        },
        {
          placeholder: "To price",
          query: {
            op: "lte",
            value: 900000000000,
          },
        },
      ],
    },
    order: 1,
    more: false,
    default: null,
    graphqlType: "Float",
    quickOptions: [
      { label: "أقل من 1.2 مليون", value: "1", where: { lt: 1200000 } },
      {
        label: "أقل من 2 مليون",
        value: "2",
        where: { gte: 1200000, lt: 2000000 },
      },
      {
        label: "أقل من 5 مليون",
        value: "3",
        where: { gte: 2000000, lt: 5000000 },
      },
      { label: "فلل وقصور فاخرة", value: "4", where: { gte: 5000000 } },
    ],
  },
  villaPrice: {
    name: {
      ar: "السعر",
      en: "Price",
    },
    key: "villaPrice",
    elasticName: "price",
    urlName: "price_category",
    type: "taps",
    quickType: "taps",
    quickOptions: [
      { label: "أقل من 1.2 مليون", value: "1", where: { lt: 1200000 } },
      {
        label: "أقل من 2 مليون",
        value: "2",
        where: { gte: 1200000, lt: 2000000 },
      },
      {
        label: "أقل من 5 مليون",
        value: "3",
        where: { gte: 2000000, lt: 5000000 },
      },
      { label: "فلل وقصور فاخرة", value: "4", where: { gte: 5000000 } },
    ],
  },
  wc: {
    key: "wc",
    name: {
      ar: "دورات المياه",
      en: "WC",
    },
    urlName: "wc",
    elasticName: "wc",
    type: "taps",
    quickType: "taps",
    options: {
      ar: [
        { label: "الكل", value: undefined },
        { label: "+1", value: "1", where: { gte: 1 } },
        { label: "+2", value: "2", where: { gte: 2 } },
        { label: "+3", value: "3", where: { gte: 3 } },
      ],
      en: [
        { label: "All", value: undefined },
        { label: "+1", value: "1", where: { gte: 1 } },
        { label: "+2", value: "2", where: { gte: 2 } },
        { label: "+3", value: "3", where: { gte: 3 } },
      ],
    },
    quickOptions: [
      { label: "+1", value: "1", where: { gte: 1 } },
      { label: "+2", value: "2", where: { gte: 2 } },
      { label: "+3", value: "3", where: { gte: 3 } },
    ],
    order: 7,
    default: 0,
    graphqlType: "Int",
  },
  meter_price: {
    key: "meter_price",
    elasticName: "meter_price",
    name: {
      ar: "سعر المتر",
      en: "Meter price",
    },
    urlName: "meter_price",
    type: "picker",
    quickType: "taps",
    options: {
      ar: [
        { label: "الكل", value: undefined },
        { label: "أقل من 1500 ريال", value: "1", where: { lte: 1500 } },
        { label: "أقل من 3 ألف ريال", value: "2", where: { lte: 3000 } },
        { label: "أقل من 10 ألف ريال", value: "3", where: { lte: 10000 } },
        { label: "أقل من 20 ألف ريال", value: "4", where: { lte: 20000 } },
        { label: "أكثر من 20 ألف ريال", value: "5", where: { gte: 20000 } },
      ],
      en: [
        { label: "All", value: undefined },
        { label: "Less than 1500 SAR", value: "1", where: { lte: 1500 } },
        { label: "Less than 3K SAR", value: "2", where: { lte: 3000 } },
        { label: "Less than 10K SAR", value: "3", where: { lte: 10000 } },
        { label: "Less than 20K SAR", value: "4", where: { lte: 20000 } },
        { label: "More than 20K SAR", value: "5", where: { gte: 20000 } },
      ],
    },
    quickOptions: [
      { label: "أقل من 1500 ريال", value: "1", where: { lte: 1500 } },
      { label: "أقل من 3 ألف ريال", value: "2", where: { lte: 3000 } },
      { label: "أقل من 10 ألف ريال", value: "3", where: { lte: 10000 } },
      { label: "أقل من 20 ألف ريال", value: "4", where: { lte: 20000 } },
      { label: "أكثر من 20 ألف ريال", value: "5", where: { gte: 20000 } },
    ],
    order: 12,
    more: true,
    default: null,
    graphqlType: "Float",
  },
  age: {
    key: "age",
    name: {
      ar: "عمر العقار",
      en: "Age",
    },
    urlName: "age",
    elasticName: "age",
    type: "picker",
    quickType: "taps",
    options: {
      ar: [
        { label: "الكل", value: undefined },
        { label: "أقل من سنة", value: "1", where: { lte: 1 } },
        { label: "أقل من 2 سنة", value: "2", where: { lte: 2 } },
        { label: "أقل من 3 سنة", value: "3", where: { lte: 3 } },
        { label: "أقل من 4 سنة", value: "4", where: { lte: 4 } },
        { label: "أقل من 5 سنة", value: "5", where: { lte: 5 } },
        { label: "أقل من 6 سنة", value: "6", where: { lte: 6 } },
        { label: "أقل من 7 سنة", value: "7", where: { lte: 7 } },
        { label: "أقل من 8 سنة", value: "8", where: { lte: 8 } },
        { label: "أقل من 9 سنة", value: "9", where: { lte: 9 } },
        { label: "أقل من 10 سنة", value: "10", where: { lte: 10 } },
        { label: "أقل من 11 سنة", value: "11", where: { lte: 11 } },
        { label: "أقل من 12 سنة", value: "12", where: { lte: 12 } },
        { label: "أقل من 13 سنة", value: "13", where: { lte: 13 } },
        { label: "أقل من 14 سنة", value: "14", where: { lte: 14 } },
        { label: "أقل من 15 سنة", value: "15", where: { lte: 15 } },
        { label: "أقل من 16 سنة", value: "16", where: { lte: 16 } },
        { label: "أقل من 17 سنة", value: "17", where: { lte: 17 } },
        { label: "أقل من 18 سنة", value: "18", where: { lte: 18 } },
        { label: "أقل من 19 سنة", value: "19", where: { lte: 19 } },
        { label: "أقل من 20 سنة", value: "20", where: { lte: 20 } },
        { label: "أقل من 21 سنة", value: "21", where: { lte: 21 } },
        { label: "أقل من 22 سنة", value: "22", where: { lte: 22 } },
        { label: "أقل من 23 سنة", value: "23", where: { lte: 23 } },
        { label: "أقل من 24 سنة", value: "24", where: { lte: 24 } },
        { label: "أقل من 25 سنة", value: "25", where: { lte: 25 } },
        { label: "أقل من 26 سنة", value: "26", where: { lte: 26 } },
        { label: "أقل من 27 سنة", value: "27", where: { lte: 27 } },
        { label: "أقل من 28 سنة", value: "28", where: { lte: 28 } },
        { label: "أقل من 29 سنة", value: "29", where: { lte: 29 } },
        { label: "أقل من 30 سنة", value: "30", where: { lte: 30 } },
        { label: "أقل من 31 سنة", value: "31", where: { lte: 31 } },
        { label: "أقل من 32 سنة", value: "32", where: { lte: 32 } },
        { label: "أقل من 33 سنة", value: "33", where: { lte: 33 } },
        { label: "أقل من 34 سنة", value: "34", where: { lte: 34 } },
        { label: "أقل من 35 سنة", value: "35", where: { lte: 35 } },
      ],
      en: [
        { label: "الكل", value: undefined },
        { label: "Less than year", value: "1", where: { lte: 1 } },
        { label: "Less than 2 year", value: "2", where: { lte: 2 } },
        { label: "Less than 3 year", value: "3", where: { lte: 3 } },
        { label: "Less than 4 year", value: "4", where: { lte: 4 } },
        { label: "Less than 5 year", value: "5", where: { lte: 5 } },
        { label: "Less than 6 year", value: "6", where: { lte: 6 } },
        { label: "Less than 7 year", value: "7", where: { lte: 7 } },
        { label: "Less than 8 year", value: "8", where: { lte: 8 } },
        { label: "Less than 9 year", value: "9", where: { lte: 9 } },
        { label: "Less than 10 year", value: "10", where: { lte: 10 } },
        { label: "Less than 11 year", value: "11", where: { lte: 11 } },
        { label: "Less than 12 year", value: "12", where: { lte: 12 } },
        { label: "Less than 13 year", value: "13", where: { lte: 13 } },
        { label: "Less than 14 year", value: "14", where: { lte: 14 } },
        { label: "Less than 15 year", value: "15", where: { lte: 15 } },
        { label: "Less than 16 year", value: "16", where: { lte: 16 } },
        { label: "Less than 17 year", value: "17", where: { lte: 17 } },
        { label: "Less than 18 year", value: "18", where: { lte: 18 } },
        { label: "Less than 19 year", value: "19", where: { lte: 19 } },
        { label: "Less than 20 year", value: "20", where: { lte: 20 } },
        { label: "Less than 21 year", value: "21", where: { lte: 21 } },
        { label: "Less than 22 year", value: "22", where: { lte: 22 } },
        { label: "Less than 23 year", value: "23", where: { lte: 23 } },
        { label: "Less than 24 year", value: "24", where: { lte: 24 } },
        { label: "Less than 25 year", value: "25", where: { lte: 25 } },
        { label: "Less than 26 year", value: "26", where: { lte: 26 } },
        { label: "Less than 27 year", value: "27", where: { lte: 27 } },
        { label: "Less than 28 year", value: "28", where: { lte: 28 } },
        { label: "Less than 29 year", value: "29", where: { lte: 29 } },
        { label: "Less than 30 year", value: "30", where: { lte: 30 } },
        { label: "Less than 31 year", value: "31", where: { lte: 31 } },
        { label: "Less than 32 year", value: "32", where: { lte: 32 } },
        { label: "Less than 33 year", value: "33", where: { lte: 33 } },
        { label: "Less than 34 year", value: "34", where: { lte: 34 } },
        { label: "Less than 35 year", value: "35", where: { lte: 35 } },
      ],
    },
    quickOptions: [
      { label: "أقل من 2 سنة", value: "2", where: { lte: 2 } },
      { label: "أقل من 5 سنة", value: "5", where: { lte: 5 } },
      { label: "أقل من 10 سنة", value: "10", where: { lte: 10 } },
      { label: "أقل من 15 سنة", value: "15", where: { lte: 15 } },
    ],
    more: true,
    order: 13,
    default: 0,
    graphqlType: "Int",
  },
  area: {
    key: "area",
    type: "two-input-range",
    quickType: "two-input-range",
    urlName: "area_range",
    elasticName: "area",
    name: {
      ar: "المساحة",
      en: "Area(m2)",
    },
    fields: {
      ar: [
        {
          placeholder: "أقل مساحة",
          query: {
            op: "gte",
            value: 0,
          },
        },
        {
          placeholder: "أعلى مساحة",
          query: {
            op: "lte",
            value: 900000000000,
          },
        },
      ],
      en: [
        {
          placeholder: "From area",
          query: {
            op: "gte",
            value: 0,
          },
        },
        {
          placeholder: "To area",
          query: {
            op: "lte",
            value: 900000000000,
          },
        },
      ],
    },
    order: 7,
    more: false,
    default: null,
    graphqlType: "Float",
  },
  aptFl: {
    key: "fl",
    elasticName: "fl",
    name: {
      ar: "رقم الدور",
      en: "Floor",
    },
    urlName: "fl",
    type: "picker",
    quickType: "taps",
    quickOptions: [{ label: "دور أرضي", value: "1", where: { eq: 1 } }],
    order: 8,
    more: false,
    default: null,
    graphqlType: "Float",
  },
  fl: {
    key: "fl",
    elasticName: "fl",
    name: {
      ar: "رقم الدور",
      en: "Floor",
    },
    urlName: "fl",
    type: "picker",
    quickType: "taps",
    options: {
      ar: [
        { label: "الكل", value: undefined },
        { label: "دور أرضي", value: "1", where: { eq: 1 } },
        { label: "دور علوي", value: "2", where: { eq: 2 } },
        { label: "الدور 3", value: "3", where: { eq: 3 } },
        { label: "الدور 4", value: "4", where: { eq: 4 } },
        { label: "الدور 5", value: "5", where: { eq: 5 } },
        { label: "الدور 6", value: "6", where: { eq: 6 } },
        { label: "الدور 7", value: "7", where: { eq: 7 } },
        { label: "الدور 8", value: "8", where: { eq: 8 } },
        { label: "الدور 9", value: "9", where: { eq: 9 } },
        { label: "الدور 10", value: "10", where: { eq: 10 } },
        { label: "الدور 11", value: "11", where: { eq: 11 } },
        { label: "الدور 12", value: "12", where: { eq: 12 } },
        { label: "الدور 13", value: "13", where: { eq: 13 } },
        { label: "الدور 14", value: "14", where: { eq: 14 } },
        { label: "الدور 15", value: "15", where: { eq: 15 } },
        { label: "الدور 16", value: "16", where: { eq: 16 } },
        { label: "الدور 17", value: "17", where: { eq: 17 } },
        { label: "الدور 18", value: "18", where: { eq: 18 } },
        { label: "الدور 19", value: "19", where: { eq: 19 } },
        { label: "الدور 20", value: "20", where: { eq: 20 } },
      ],
      en: [
        { label: "الكل", value: undefined },
        { label: "First floor", value: "1", where: { eq: 1 } },
        { label: "Second floor", value: "2", where: { eq: 2 } },
        { label: "3", value: "3", where: { eq: 3 } },
        { label: "4", value: "4", where: { eq: 4 } },
        { label: "5", value: "5", where: { eq: 5 } },
        { label: "6", value: "6", where: { eq: 6 } },
        { label: "7", value: "7", where: { eq: 7 } },
        { label: "8", value: "8", where: { eq: 8 } },
        { label: "9", value: "9", where: { eq: 9 } },
        { label: "10", value: "10", where: { eq: 10 } },
        { label: "11", value: "11", where: { eq: 11 } },
        { label: "12", value: "12", where: { eq: 12 } },
        { label: "13", value: "13", where: { eq: 13 } },
        { label: "14", value: "14", where: { eq: 14 } },
        { label: "15", value: "15", where: { eq: 15 } },
        { label: "16", value: "16", where: { eq: 16 } },
        { label: "17", value: "17", where: { eq: 17 } },
        { label: "18", value: "18", where: { eq: 18 } },
        { label: "19", value: "19", where: { eq: 19 } },
        { label: "20", value: "20", where: { eq: 20 } },
      ],
    },
    quickOptions: [
      { label: "دور أرضي", value: "1", where: { eq: 1 } },
      { label: "دور علوي", value: "2", where: { eq: 2 } },
      { label: "الدور 3", value: "3", where: { eq: 3 } },
      { label: "الدور 4", value: "4", where: { eq: 4 } },
      { label: "الدور 5+ ", value: "5", where: { gte: 5 } },
    ],
    order: 8,
    more: false,
    default: null,
    graphqlType: "Float",
  },
  rent_period: {
    key: "rent_period",
    name: {
      ar: "مدة الإيجار",
      en: "Rent period",
    },
    urlName: "rent_type",
    elasticName: "rent_period",
    type: "taps",
    quickType: "taps",
    options: {
      ar: [
        { label: "يومي", value: "1", where: { eq: 1 } },
        { label: "شهري", value: "2", where: { eq: 2 } },
        { label: "سنوي", value: "3", where: { eq: 3 } },
      ],
      en: [
        { label: "Daily", value: "1", where: { eq: 1 } },
        { label: "Monthly", value: "2", where: { eq: 2 } },
        { label: "Yearly", value: "3", where: { eq: 3 } },
      ],
    },
    quickOptions: [
      { label: "يومي", value: "1", where: { eq: 1 } },
      { label: "شهري", value: "2", where: { eq: 2 } },
      { label: "سنوي", value: "3", where: { eq: 3 } },
    ],
    order: 1,
    default: null,
    graphqlType: "Int",
  },
  beds: {
    elasticName: "beds",
    name: {
      ar: "الغرف",
      en: "Bed rooms",
    },
    urlName: "bed_rooms",
    key: "beds",
    type: "taps",
    quickType: "taps",
    options: {
      ar: [
        { label: "الكل", value: undefined },
        { label: "غرفتين", value: "2", where: { eq: 2 } },
        { label: "٣ غرف", value: "3", where: { eq: 3 } },
        { label: "٤ غرف", value: "4", where: { eq: 4 } },
      ],
      en: [
        { label: "الكل", value: undefined },
        { label: "2 BR", value: "2", where: { eq: 2 } },
        { label: "3 BR", value: "3", where: { eq: 3 } },
        { label: "4 Br", value: "4", where: { eq: 4 } },
      ],
    },
    quickOptions: [
      { label: "غرفتين", value: "2", where: { eq: 2 } },
      { label: "ثلاث غرف", value: "3", where: { eq: 3 } },
      { label: "أربع غرف", value: "4", where: { eq: 4 } },
      { label: "غرف أكثر", value: "5", where: { gt: 5 } },
    ],
    order: 2,
    default: null,
    graphqlType: "Int",
  },
  livings: {
    key: "livings",
    elasticName: "livings",
    name: {
      ar: "الصالات",
      en: "Living rooms",
    },
    urlName: "living_rooms",
    type: "taps",
    quickType: "taps",
    options: {
      ar: [
        { label: "الكل", value: undefined },
        { label: "+1", value: "1", where: { gte: 1 } },
        { label: "+2", value: "2", where: { gte: 2 } },
        { label: "+3", value: "3", where: { gte: 3 } },
      ],
      en: [
        { label: "All", value: undefined },
        { label: "+1", value: "1", where: { gte: 1 } },
        { label: "+2", value: "2", where: { gte: 2 } },
        { label: "+3", value: "3", where: { gte: 3 } },
      ],
    },
    quickOptions: [
      { label: "أكثر من صالة", value: "1", where: { gte: 1 } },
      { label: "أكثر من صالتين", value: "2", where: { gte: 2 } },
      { label: "أكثر من ٣ صالات", value: "3", where: { gte: 3 } },
    ],
    order: 6,
    default: null,
    graphqlType: "Int",
  },
  ketchen: {
    key: "ketchen",
    name: {
      ar: "مطبخ",
      en: "Kitchen",
    },
    urlName: "Kitchen",
    elasticName: "ketchen",
    type: "radio",
    quickType: "radio",
    order: 23,
    default: 1,
    graphqlType: "Int",
    options: {
      ar: [
        { label: "الكل", value: null },
        { label: "مطبخ موجود", value: 1, where: "{eq: 1}" },
      ],
    },
  },
  apts: {
    key: "apts",
    name: {
      ar: "عدد الشقق",
      en: "Apartments",
    },
    urlName: "apts",
    elasticName: "apts",
    type: "taps",
    quickType: "taps",
    options: {
      ar: [
        { label: "الكل", value: "0" },
        { label: "1", value: "1", where: { eq: 1 } },
        { label: "2", value: "2", where: { eq: 2 } },
        { label: "3", value: "3", where: { eq: 3 } },
        { label: "4", value: "4", where: { eq: 4 } },
      ],
      en: [
        { label: "All", value: "0" },
        { label: "1", value: "1", where: { eq: 1 } },
        { label: "2", value: "2", where: { eq: 2 } },
        { label: "3", value: "3", where: { eq: 3 } },
        { label: "4", value: "4", where: { eq: 4 } },
      ],
    },
    quickOptions: [
      { label: "شقة واحدة", value: "1", where: { eq: 1 } },
      { label: "شقتان", value: "2", where: { eq: 2 } },
      { label: "٣ شقق", value: "3", where: { eq: 3 } },
      { label: "٤ شقق", value: "4", where: { eq: 4 } },
    ],
    order: 1,
    default: 0,
    graphqlType: "Int",
  },
  stores: {
    key: "stores",
    name: {
      ar: "المحلات",
      en: "Stores",
    },
    urlName: "stores",
    elasticName: "stores",
    type: "picker",
    quickType: "taps",
    options: {
      ar: [
        { label: "الكل", value: null },
        { label: "أقل من 4", value: "1", where: { lte: 4 } },
        { label: "أكثر من 5", value: "2", where: { gte: 5 } },
      ],
      en: [
        { label: "All", value: undefined },
        { label: "Less than 4 store", value: "1", where: { lte: 4 } },
        { label: "More than 5 store", value: "2", where: { lte: 5 } },
      ],
    },
    quickOptions: [
      { label: "أقل من 4", value: "1", where: { lte: 4 } },
      { label: "أكثر من 5", value: "2", where: { gte: 5 } },
    ],
    order: 5,
    default: 0,
    graphqlType: "Int",
  },
  duplex: {
    key: "duplex",
    name: {
      ar: "دوبلكس",
      en: "Duplex",
    },
    urlName: "duplex",
    elasticName: "duplex",
    type: "radio",
    quickType: "radio",
    values: {
      ar: ["لا يوجد", "يوجد"],
      en: ["Not available", "Available"],
    },
    page: 1,
    order: 34,
    default: 0,
    graphqlType: "Int",
    options: {
      ar: [
        { label: "الكل", value: null },
        { label: "دوبلكس", value: 1, where: "{eq: 1}" },
      ],
    },
  },
  furnished: {
    key: "furnished",
    name: {
      ar: "مؤثثة",
      en: "Furnished",
    },
    urlName: "furnished",
    elasticName: "furnished",
    type: "radio",
    quickType: "radio",
    values: {
      ar: ["لا يوجد", "يوجد"],
      en: ["Not available", "Available"],
    },
    page: 1,
    order: 18,
    default: 0,
    graphqlType: "Int",
    options: {
      ar: [
        { label: "الكل", value: null },
        { label: "مؤثثة", value: 1, where: "{eq: 1}" },
      ],
    },
  },
  driver: {
    key: "driver",
    name: {
      ar: "غرفة سائق",
      en: "Driver room",
    },
    urlName: "driver",
    elasticName: "driver",
    type: "radio",
    quickType: "radio",
    values: {
      ar: ["لا يوجد", "يوجد"],
      en: ["Not available", "Available"],
    },
    page: 1,
    order: 15,
    default: 0,
    graphqlType: "Int",
    options: {
      ar: [
        { label: "الكل", value: null },
        { label: "غرفة سائق", value: 1, where: "{eq: 1}" },
      ],
    },
  },
  maid: {
    key: "maid",
    name: {
      ar: "غرفة خادمة",
      en: "Maid room",
    },
    urlName: "maid",
    elasticName: "maid",
    type: "radio",
    quickType: "radio",
    values: {
      ar: ["لا يوجد", "يوجد"],
      en: ["Not available", "Available"],
    },
    page: 1,
    order: 16,
    default: 0,
    graphqlType: "Int",
    options: {
      ar: [
        { label: "الكل", value: null },
        { label: "غرفة خادمة", value: 1, where: "{eq: 1}" },
      ],
    },
  },
  basement: {
    key: "basement",
    name: {
      ar: "قبو",
      en: "Basement",
    },
    urlName: "basement",
    elasticName: "basement",
    type: "radio",
    quickType: "radio",
    values: {
      ar: ["لا يوجد", "يوجد"],
      en: ["Not available", "Available"],
    },
    page: 1,
    order: 29,
    default: 0,
    graphqlType: "Int",
    options: {
      ar: [
        { label: "الكل", value: null },
        { label: "يوجد قبو", value: 1, where: "{eq: 1}" },
      ],
    },
  },
  lift: {
    key: "lift",
    name: {
      ar: "مصعد",
      en: "Lift",
    },
    urlName: "lift",
    elasticName: "lift",
    type: "radio",
    quickType: "radio",
    values: {
      ar: ["لا يوجد", "يوجد"],
      en: ["Not available", "Available"],
    },
    page: 1,
    order: 30,
    default: 0,
    graphqlType: "Int",
    options: {
      ar: [
        { label: "الكل", value: null },
        { label: "يوجد مصعد", value: 1, where: "{eq: 1}" },
      ],
    },
  },
  pool: {
    key: "pool",
    name: {
      ar: "مسبح",
      en: "Pool",
    },
    urlName: "pool",
    elasticName: "pool",
    type: "radio",
    quickType: "radio",
    values: {
      ar: ["لا يوجد", "يوجد"],
      en: ["Not available", "Available"],
    },
    page: 1,
    order: 17,
    default: 0,
    graphqlType: "Int",
    options: {
      ar: [
        { label: "الكل", value: null },
        { label: "يوجد مسبح", value: 1, where: "{eq: 1}" },
      ],
    },
  },
  stairs: {
    key: "stairs",
    name: {
      ar: "درج صالة",
      en: "Stairs",
    },
    urlName: "stairs",
    elasticName: "stairs",
    type: "radio",
    quickType: "radio",
    values: {
      ar: ["لا يوجد", "يوجد"],
      en: ["Not available", "Available"],
    },
    page: 1,
    order: 10,
    default: 0,
    graphqlType: "Int",
    options: {
      ar: [
        { label: "الكل", value: null },
        { label: "يوجد درج صالة", value: 1, where: "{eq: 1}" },
      ],
    },
  },
  fb: {
    key: "fb",
    elasticName: "fb",
    name: {
      ar: "ملعب كرة قدم",
      en: "Football pitch",
    },
    urlName: "football",
    type: "radio",
    quickType: "radio",
    values: {
      ar: ["لا يوجد", "يوجد"],
      en: ["Not available", "Available"],
    },
    page: 1,
    order: 19,
    default: 0,
    graphqlType: "Int",
    options: {
      ar: [
        { label: "الكل", value: null },
        { label: "يوجد ملعب كرة قدم", value: 1, where: "{eq: 1}" },
      ],
    },
  },
  vb: {
    key: "vb",
    elasticName: "vb",
    name: {
      ar: "ملعب كرة طائرة",
      en: "Volleyball Court",
    },
    urlName: "volleyball",
    type: "radio",
    quickType: "radio",
    values: {
      ar: ["لا يوجد", "يوجد"],
      en: ["Not available", "Available"],
    },
    page: 1,
    order: 20,
    default: 0,
    graphqlType: "Int",
    options: {
      ar: [
        { label: "الكل", value: null },
        { label: "يوجد ملعب كرة طائرة", value: 1, where: "{eq: 1}" },
      ],
    },
  },
  playground: {
    key: "playground",
    name: {
      ar: "ملاهي",
      en: "Playground",
    },
    urlName: "playground",
    elasticName: "playground",
    type: "radio",
    quickType: "radio",
    values: {
      ar: ["لا يوجد", "يوجد"],
      en: ["Not available", "Available"],
    },
    page: 1,
    order: 24,
    default: 0,
    graphqlType: "Int",
    options: {
      ar: [
        { label: "الكل", value: null },
        { label: "يوجد ملاهي", value: 1, where: { eq: 1 } },
      ],
    },
  },
  family: {
    name: {
      ar: "نوع الإيجار",
      en: "Rent type",
    },
    key: "family",
    urlName: "family",
    elasticName: "family",
    type: "taps",
    quickType: "taps",
    options: {
      ar: [
        { label: "عزاب", value: "0", where: { eq: 0 } },
        { label: "عوائل", value: "1", where: { eq: 1 } },
      ],
      en: [
        { label: "Single", value: "0", where: { eq: 0 } },
        { label: "family", value: "1", where: { eq: 1 } },
      ],
    },
    quickOptions: [
      { label: "عوائل", value: "1", where: { eq: 1 } },
      { label: "عزاب", value: "0", where: { eq: 0 } },
    ],
    order: -2,
    default: null,
    graphqlType: "Int",
  },
  aptBeds: {
    name: {
      ar: "الغرف",
      en: "Bed rooms",
    },
    elasticName: "beds",
    urlName: "bed_rooms",
    quickType: "taps",
    quickOptions: [
      { label: "غرفتين", value: "2", where: { eq: 2 } },
      { label: "ثلاث غرف", value: "3", where: { eq: 3 } },
      { label: "أربع غرف", value: "4", where: { eq: 4 } },
    ],
  },
  family_section: {
    key: "family_section",
    elasticName: "family_section",
    name: {
      ar: "قسم عوائل",
      en: "Family section",
    },
    urlName: "family_section",
    type: "radio",
    quickType: "radio",
    values: {
      ar: ["لا يوجد", "يوجد"],
      en: ["Not available", "Available"],
    },
    page: 1,
    order: 1009,
    default: 0,
    graphqlType: "Int",
    options: {
      ar: [
        { label: "الكل", value: null },
        { label: "يوجد قسم عوائل", value: 1, where: "{eq: 1}" },
      ],
    },
  },
  street_direction: {
    key: "street_direction",
    elasticName: "street_direction",
    name: {
      ar: "الواجهة",
      en: "Street direction",
    },
    urlName: "street_direction",
    type: "picker",
    quickType: "taps",
    options: {
      ar: [
        { label: "الكل", value: undefined },
        { label: "شمال", value: "1", where: { eq: 1 } },
        { label: "شرق", value: "2", where: { eq: 2 } },
        { label: "غرب", value: "3", where: { eq: 3 } },
        { label: "جنوب", value: "4", where: { eq: 4 } },
        { label: "شمالي شرقي", value: "5", where: { eq: 5 } },
        { label: "جنوب شرقي", value: "6", where: { eq: 6 } },
        { label: "جنوب غربي", value: "7", where: { eq: 7 } },
        { label: "شمال غربي", value: "8", where: { eq: 8 } },
        { label: "3 شوارع", value: "9", where: { eq: 9 } },
        { label: "4 شوارع", value: "10", where: { eq: 10 } },
      ],
      en: [
        { label: "الكل", value: undefined },
        { label: "North", value: "1", where: { eq: 1 } },
        { label: "East", value: "2", where: { eq: 2 } },
        { label: "West", value: "3", where: { eq: 3 } },
        { label: "South", value: "4", where: { eq: 4 } },
        { label: "Northeast", value: "5", where: { eq: 5 } },
        { label: "Southeast", value: "6", where: { eq: 6 } },
        { label: "Southwest", value: "7", where: { eq: 7 } },
        { label: "Northwest", value: "8", where: { eq: 8 } },
        { label: "3 Streets", value: "9", where: { eq: 9 } },
        { label: "4 Streets", value: "10", where: { eq: 10 } },
      ],
    },
    quickOptions: [
      { label: "شمال", value: "1", where: { eq: 1 } },
      { label: "شرق", value: "2", where: { eq: 2 } },
      { label: "غرب", value: "3", where: { eq: 3 } },
      { label: "جنوب", value: "4", where: { eq: 4 } },
      { label: "شمالي شرقي", value: "5", where: { eq: 5 } },
      { label: "جنوب شرقي", value: "6", where: { eq: 6 } },
      { label: "جنوب غربي", value: "7", where: { eq: 7 } },
      { label: "شمال غربي", value: "8", where: { eq: 8 } },
      { label: "3 شوارع", value: "9", where: { eq: 9 } },
      { label: "4 شوارع", value: "10", where: { eq: 10 } },
    ],
    order: 4,
    more: false,
    default: 0,
    graphqlType: "Float",
  },
  street_width: {
    key: "street_width",
    elasticName: "street_width",
    name: {
      ar: "عرض الشارع",
      en: "Street width",
    },
    urlName: "street_width",
    type: "picker",
    quickType: "taps",
    called: {
      ar: "عرض الشارع %s متر",
    },
    options: {
      ar: [
        { label: "الكل", value: undefined },
        { label: "أكثر من 5م", value: "5", where: { gte: 5 } },
        { label: "أكثر من 10م", value: "10", where: { gte: 10 } },
        { label: "أكثر من 15م", value: "15", where: { gte: 15 } },
        { label: "أكثر من 20م", value: "20", where: { gte: 20 } },
        { label: "أكثر من 25م", value: "25", where: { gte: 25 } },
        { label: "أكثر من 30م", value: "30", where: { gte: 30 } },
        { label: "أكثر من 35م", value: "35", where: { gte: 35 } },
        { label: "أكثر من 40م", value: "40", where: { gte: 40 } },
        { label: "أكثر من 45م", value: "45", where: { gte: 45 } },
        { label: "أكثر من 50م", value: "50", where: { gte: 50 } },
      ],
      en: [
        { label: "All", value: undefined },
        { label: "More than 5", value: "5", where: { gte: 5 } },
        { label: "More than 10", value: "10", where: { gte: 10 } },
        { label: "More than 15", value: "15", where: { gte: 15 } },
        { label: "More than 20", value: "20", where: { gte: 20 } },
        { label: "More than 25", value: "25", where: { gte: 25 } },
        { label: "More than 30", value: "30", where: { gte: 30 } },
        { label: "More than 35", value: "35", where: { gte: 35 } },
        { label: "More than 40", value: "40", where: { gte: 40 } },
        { label: "More than 45", value: "45", where: { gte: 45 } },
        { label: "More than 50", value: "50", where: { gte: 50 } },
      ],
    },
    quickOptions: [
      { label: "أكثر من 5م", value: "5", where: { gte: 5 } },
      { label: "أكثر من 10م", value: "10", where: { gte: 10 } },
      { label: "أكثر من 15م", value: "15", where: { gte: 15 } },
      { label: "أكثر من 20م", value: "20", where: { gte: 20 } },
      { label: "أكثر من 30م", value: "30", where: { gte: 30 } },
      { label: "أكثر من 50م", value: "50", where: { gte: 50 } },
    ],
    more: false,
    order: 7,
    default: 1,
    graphqlType: "Int",
  },
  type: {
    key: "type",
    elasticName: "type",
    name: {
      ar: "نوع العقار",
      en: "Residential and commercial",
    },
    urlName: "type",
    type: "taps",
    quickType: "taps",
    options: {
      ar: [
        { label: "سكني", value: "1", where: { eq: 1 } },
        { label: "تجاري", value: "2", where: { eq: 2 } },
      ],
      en: [
        { label: "Residential", value: "1", where: { eq: 1 } },
        { label: "Commercial", value: "2", where: { eq: 2 } },
      ],
    },
    quickOptions: [
      { label: "سكني", value: "1", where: { eq: 1 } },
      { label: "تجاري", value: "2", where: { eq: 2 } },
    ],
    page: 1,
    order: 3,
    default: null,
    graphqlType: "Int",
  },
  car_entrance: {
    key: "car_entrance",
    elasticName: "car_entrance",
    name: {
      ar: "مدخل سيارة",
      en: "Car entrance",
    },
    urlName: "car_entrance",
    type: "radio",
    quickType: "radio",
    values: {
      ar: ["لا يوجد", "يوجد"],
      en: ["Not available", "Available"],
    },
    page: 1,
    order: 28,
    default: 0,
    graphqlType: "Int",
    options: {
      ar: [
        { label: "الكل", value: null },
        { label: "يوجد مدخل سيارة", value: 1, where: "{eq: 1}" },
      ],
    },
  },
  ac: {
    key: "ac",
    elasticName: "ac",
    name: {
      ar: "مكيفات؟",
      en: "Air conditioned",
    },
    urlName: "ac",
    type: "radio",
    quickType: "radio",
    values: {
      ar: ["لا يوجد", "يوجد"],
      en: ["Not available", "Available"],
    },
    page: 1,
    order: 35,
    default: 0,
    graphqlType: "Int",
    options: {
      ar: [
        { label: "الكل", value: null },
        { label: "يوجد مكيف", value: 1, where: "{eq: 1}" },
      ],
    },
  },
  extra_unit: {
    key: "extra_unit",
    elasticName: "extra_unit",
    name: {
      ar: "ملحق",
      en: "Extra unit",
    },
    urlName: "extra_unit",
    type: "radio",
    quickType: "radio",
    values: {
      ar: ["لا يوجد", "يوجد"],
      en: ["Not available", "Available"],
    },
    page: 1,
    order: 25,
    default: 0,
    graphqlType: "Int",
    options: {
      ar: [
        { label: "الكل", value: null },
        { label: "extra unit available", value: 1, where: "{eq: 1}" },
      ],
    },
  },
  tent: {
    key: "tent",
    elasticName: "tent",
    name: {
      ar: "خيمة",
      en: "tent",
    },
    urlName: "tent",
    type: "radio",
    quickType: "radio",
    values: {
      ar: ["لا يوجد", "يوجد"],
      en: ["Not available", "Available"],
    },
    page: 1,
    order: 25,
    default: 0,
    graphqlType: "Int",
    options: {
      ar: [
        { label: "الكل", value: null },
        { label: "يوجد خيمة", value: 1, where: "{eq: 1}" },
      ],
    },
  },
  private_roof: {
    key: "private_roof",
    elasticName: "private_roof",
    name: {
      ar: "سطح خاص",
      en: "private_roof",
    },
    urlName: "private roof",
    type: "radio",
    quickType: "radio",
    values: {
      ar: ["لا يوجد", "يوجد"],
      en: ["Not available", "Available"],
    },
    page: 1,
    order: 25,
    default: 0,
    graphqlType: "Int",
    options: {
      ar: [
        { label: "الكل", value: null },
        { label: "يوجد سطح خاص", value: 1, where: "{eq: 1}" },
      ],
    },
  },
  apartment_in_villa: {
    key: "apartment_in_villa",
    elasticName: "apartment_in_villa",
    name: {
      ar: "في فيلا",
      en: "apartment in villa",
    },
    urlName: "apartment_in_villa",
    type: "radio",
    quickType: "radio",
    values: {
      ar: ["لا يوجد", "يوجد"],
      en: ["Not available", "Available"],
    },
    page: 1,
    order: 25,
    default: 0,
    graphqlType: "Int",
    options: {
      ar: [
        { label: "الكل", value: null },
        { label: "يوجد في فيلا", value: 1, where: "{eq: 1}" },
      ],
    },
  },
  two_entrances: {
    key: "two_entrances",
    elasticName: "two_entrances",
    name: {
      ar: "مدخلين",
      en: "two entrances",
    },
    urlName: "two_entrances",
    type: "radio",
    quickType: "radio",
    values: {
      ar: ["لا يوجد", "يوجد"],
      en: ["Not available", "Available"],
    },
    page: 1,
    order: 25,
    default: 0,
    graphqlType: "Int",
    options: {
      ar: [
        { label: "الكل", value: null },
        { label: "يوجد مدخلين", value: 1, where: "{eq: 1}" },
      ],
    },
  },
  special_entrance: {
    key: "special_entrance",
    elasticName: "special_entrance",
    name: {
      ar: "مدخل خاص",
      en: "special entrance",
    },
    urlName: "special_entrance",
    type: "radio",
    quickType: "radio",
    values: {
      ar: ["لا يوجد", "يوجد"],
      en: ["Not available", "Available"],
    },
    page: 1,
    order: 25,
    default: 0,
    graphqlType: "Int",
    options: {
      ar: [
        { label: "الكل", value: null },
        { label: "يوجد مدخل خاص", value: 1, where: "{eq: 1}" },
      ],
    },
  },
};

export const urlNamElasticNameMap = {
  price_range: "price",
  price_category: "villaPrice",
  wc: "wc",
  meter_price: "meter_price",
  age: "age",
  area_range: "area",
  fl: "fl",
  rent_type: "rent_period",
  bed_rooms: "beds",
  living_rooms: "livings",
  kitchen: "ketchen",
  apts: "apts",
  stores: "stores",
  duplex: "duplex",
  furnished: "furnished",
  driver: "driver",
  maid: "maid",
  basement: "basement",
  lift: "lift",
  pool: "pool",
  stairs: "stairs",
  football: "fb",
  volleyball: "vb",
  playground: "playground",
  family: "family",
  family_section: "family_section",
  street_direction: "street_direction",
  street_width: "street_width",
  type: "type",
  car_entrance: "car_entrance",
  ac: "ac",
  extra_unit: "extra_unit",
};
